import { render, staticRenderFns } from "./ContentSelectionAndTag.vue?vue&type=template&id=868763b0&scoped=true&"
import script from "./ContentSelectionAndTag.vue?vue&type=script&lang=js&"
export * from "./ContentSelectionAndTag.vue?vue&type=script&lang=js&"
import style0 from "./ContentSelectionAndTag.vue?vue&type=style&index=0&id=868763b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868763b0",
  null
  
)

export default component.exports